<template>
  <el-dialog
    v-drag
    v-loading="loading"
    title="新增"
    :visible.sync="dialogVisible"
    width="800px"
    :show-close="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
  >
    <div class="content">
      <div style="margin-bottom: 10px">
        <label style="margin-right: 10px">选择年份</label>
        <el-select v-model="year" size="small">
          <el-option
            v-for="item in getYear"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>
      <BaseTable :tableData="tableData" height="535" :isPager="false">
        <template slot="estimateSalesAmount" slot-scope="row">
          <el-input
            v-model="row.scope.estimateSalesAmount"
            placeholder="请输入"
            style="width: 100%"
            oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
          >
            <span slot="suffix" class="suffix">万USD</span>
          </el-input>
        </template>
        <template slot="estimateCustomerCount" slot-scope="row">
          <el-input
            v-model="row.scope.estimateCustomerCount"
            placeholder="请输入"
            style="width: 100%"
            oninput="value=value.replace(/^[^\d]/g,'')"
          >
            <span slot="suffix" class="suffix">家</span>
          </el-input>
        </template>
      </BaseTable>
    </div>
    <span slot="footer" class="footers">
      <div class="cancel flex_c_c" @click="cancel">取 消</div>
      <div v-debounce-click="ok" class="ok flex_c_c">
        确 定
      </div>
    </span>
  </el-dialog>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
import { createYearSaleGoal } from '@/api/system'
export default {
  components: { BaseTable },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    salesUserId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      tableData: {
        fileds: [
          {
            filed: 'monthCH',
            label: '月份',
            width: 100,
            formatter: (row) => row.monthCH + '月'
          },
          {
            filed: 'estimateSalesAmount',
            label: '销售额（万USD）',
            isCustom: true
          },
          {
            filed: 'estimateCustomerCount',
            label: '新客户（家）',
            isCustom: true
          }
        ],
        columns: [],
        total: 0
      },
      year: new Date().getFullYear()
    }
  },
  computed: {
    getYear() {
      const date = new Date()
      let year = date.getFullYear() - 6
      const array = []
      const i = 9
      for (let j = 0; j < i; j++) {
        year = year + 1
        array.push(year)
      }
      return array
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.tableData.columns = Array.from({ length: 12 }, (_, index) => {
          return {
            monthCH: index + 1,
            estimateSalesAmount: 0,
            estimateCustomerCount: 0
          }
        })
      }
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    async ok() {
      this.loading = true
      try {
        const params = {
          salesUserId: this.salesUserId,
          year: this.year,
          goal: this.tableData.columns
        }
        const res = await createYearSaleGoal(params)
        this.loading = false
        if (res.success) {
          this.$message.success('生成成功')
          this.$emit('ok')
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        this.loading = false
        console.error(error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  /deep/ .el-table {
    tr td {
      padding: 0;
      .cell {
        // padding: 0;
      }
      input {
        border: 0;
      }
    }
  }
  .suffix {
    line-height: 40px;
    font-size: 14px;
    color: #666666;
    margin-right: 10px;
  }
}
.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  & > div {
    width: 120px;
    height: 40px;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    cursor: pointer;
    font-weight: 400;
  }
  .cancel {
    background: #eeeeee;
    color: #999999;
    margin-right: 16px;
  }
  .ok {
    height: 40px;
    background:  rgb(18,88,188);
    color: #ffffff;
  }
}
</style>
